function IconChevronDown({ className}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M19.5 8.25L12 15.75L4.5 8.25" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>


    );
}

export { IconChevronDown };